import { render, staticRenderFns } from "./Unidades-integracao.vue?vue&type=template&id=63270edc&"
import script from "./Unidades-integracao.vue?vue&type=script&lang=js&"
export * from "./Unidades-integracao.vue?vue&type=script&lang=js&"
import style0 from "./Unidades-integracao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports